<template>
  <div>
    <b-row>
      <b-col
        v-if="$permissionAbility(LEAD_DASHBOARD_STATUS_WIDGET, permissions)"
        cols="12"
        md="7"
        class="mb-3"
      >
        <!-- <br /> -->
        <!-- <LeadByStatusChart :key="viewAs" :view-as="viewAs" /> -->
        <!-- Pass selection to child -->
        <!-- <LeadByStatusChart
          :view-as="'admin'"
          :filter-emp-id="selectedEmpId"
          @update:filter-emp-id="selectedEmpId = $event"
        /> -->
        <LeadByStatusChart
          :key="viewAs"
          :view-as="viewAs"
          :filter-emp-id="selectedEmpId"
          @update:filter-emp-id="selectedEmpId = $event"
        />
      </b-col>

      <b-col cols="12" md="5">
        <b-button-group class="w-100 d-flex justify-content-between">
          <b-button
            :variant="viewAs === 'employee' ? 'primary' : 'outline-primary'"
            @click="viewAs = 'employee'"
          >
            My Lead
          </b-button>
          <b-button
            :variant="viewAs === 'manager' ? 'primary' : 'outline-primary'"
            @click="viewAs = 'manager'"
          >
            Manager (KAM)
          </b-button>
          <b-button
            v-if="$permissionAbility(LEAD_DASHBOARD_VIEW_AS_ADMIN, permissions)"
            :variant="viewAs === 'admin' ? 'primary' : 'outline-primary'"
            @click="
              viewAs = 'admin';
              selectedEmpId = '';
            "
          >
            Admin
          </b-button>
        </b-button-group>
        <div
          v-if="viewAs === 'admin'"
          class="mt-1 max-w-md mx-auto bg-white rounded-xl shadow-md p-2"
        >
          <!-- <h3 class="text-lg font-semibold text-gray-700 mb-3">
            Select Employee
          </h3> -->

          <!-- Employee select in parent -->
          <v-select
            v-model="selectedEmpId"
            :options="employeeOptions"
            :reduce="(emp) => emp.id"
            label="name"
            placeholder="Select Employee"
            class="w-full"
          >
            <template #option="user">
              <UserSelect :user="user" />
            </template>
          </v-select>
        </div>
        <div class="mt-2">
          <DashboardActivityLog
            v-if="$permissionAbility(LEAD_DASHBOARD_ACTIVITY_LOG, permissions)"
            :key="viewAs"
            :view-as="viewAs"
            :selected-user-id="selectedEmpId"
            @update:selected-user-id="selectedEmpId = $event"
          />
        </div>
      </b-col>

      <!-- Left Section: Tables and Chart -->
      <b-col cols="12" class="px-5">
        <b-row>
          <b-col
            v-if="
              $permissionAbility(
                LEAD_DASHBOARD_UPCOMING_APPOINTMENT,
                permissions
              )
            "
            cols="12"
            sm="4"
            class="mb-3"
          >
            <LeadUpcomingAppointment
              :key="viewAs"
              :view-as="viewAs"
              :selected-user-id="selectedEmpId"
              @update:selected-user-id="selectedEmpId = $event"
            />
          </b-col>
          <b-col
            v-if="
              $permissionAbility(LEAD_DASHBOARD_TODAY_APPOINTMENT, permissions)
            "
            cols="12"
            sm="4"
            class="mb-3"
          >
            <LeadTodayAppointment
              :key="viewAs"
              :view-as="viewAs"
              :selected-user-id="selectedEmpId"
              @update:selected-user-id="selectedEmpId = $event"
            />
          </b-col>

          <b-col
            v-if="
              $permissionAbility(
                LEAD_DASHBOARD_OVERDUE_APPOINTMENT,
                permissions
              )
            "
            cols="4"
            class="mb-3"
          >
            <LeadOverDueAppointment
              :key="viewAs"
              :view-as="viewAs"
              :selected-user-id="selectedEmpId"
              @update:selected-user-id="selectedEmpId = $event"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner,
  BTab,
  BTabs,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";

import LvColorPicker from "lightvue/color-picker";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import flatPickr from "vue-flatpickr-component";
import UserSelect from "@/layouts/components/UserSelect.vue";
import UserCard from "@/layouts/components/UserCard.vue";
import { required, max, size, ext, max_value, min_value } from "@validations";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import BCardCode from "@core/components/b-card-code";
import LeadOverDueAppointment from "@/views/admin/lead/Dashboard/Component/LeadOverDueAppointment.vue";
import LeadByStatusChart from "@/views/admin/lead/Dashboard/Component/LeadByStatusChart.vue";
import {
  LEAD_DASHBOARD_ACTIVITY_LOG,
  LEAD_DASHBOARD_STATUS_WIDGET,
  LEAD_DASHBOARD_UPCOMING_APPOINTMENT,
  LEAD_DASHBOARD_TODAY_APPOINTMENT,
  LEAD_DASHBOARD_OVERDUE_APPOINTMENT,
  LEAD_DASHBOARD_VIEW_AS_ADMIN,
} from "@/helpers/permissionsConstant";
import DashboardActivityLog from "@/views/admin/lead/Dashboard/Component/DashboardActivityLog.vue";
import LeadTodayAppointment from "@/views/admin/lead/Dashboard/Component/LeadTodayAppointment.vue";
import LeadUpcomingAppointment from "@/views/admin/lead/Dashboard/Component/LeadUpcomingAppointment.vue";

export default {
  name: "LeadDashbaord",
  components: {
    LeadUpcomingAppointment,
    LeadTodayAppointment,
    LeadOverDueAppointment,
    LeadReminder: LeadOverDueAppointment,
    DashboardActivityLog,
    LeadByStatusChart,
    Chart,
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
  },
  data() {
    return {
      LEAD_DASHBOARD_ACTIVITY_LOG,
      LEAD_DASHBOARD_STATUS_WIDGET,
      LEAD_DASHBOARD_UPCOMING_APPOINTMENT,
      LEAD_DASHBOARD_TODAY_APPOINTMENT,
      LEAD_DASHBOARD_OVERDUE_APPOINTMENT,
      LEAD_DASHBOARD_VIEW_AS_ADMIN,
      allMemberIdOptions: [],
      statistics: [],
      showSubtasks: false,
      viewAs: "employee",
      selectedEmpId: "",
      employeeOptions: [], // fetch from API like before
    };
  },

  async created() {
    try {
      const res = await this.$api.get("api/leads/assigned-users");
      this.employeeOptions = (res?.data?.data || []).map((u) => ({
        avatar: u.avatar,
        name: u.name,
        email: u.email,
        id: u.id,
      }));

      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },

  methods: {
    async loadItems() {
      try {
        // get all members
        const allMembers = await this.getAllMembers();

        this.allMemberIdOptions = allMembers?.data?.data?.map((item) => ({
          avatar: item?.avatar,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          employee_number: item?.employee_number,
          id: item?.id,
          departmentId: item?.department_id,
          inactive: !item?.status,
        }));

        const statistics = await this.$api.get(
          "api/tasks-dashboard/statistics"
        );

        this.statistics = statistics?.data;
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error.message ||
          "Failed to load members";

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: message,
          },
        });
      }
    },
    async getAllMembers() {
      return await this.$api.get("api/users/all");
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}
</style>
